import moment from "moment";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { poMonthFormate } from "jsFunctions/helperFunctions";

export const getDirectTaxExcelData = (directTaxList) => {
    let list = JSON.parse(JSON.stringify(directTaxList));
    const exportData = list.map((data, index) => {
      let content = {
        no: index + 1,
        "Order PO Number": data.poNo && poNumberFormate(data.poNo),
        "Current Order Date":
          data.oDt && moment(data.oDt).format("DD-MMM-YYYY"),
        "Current Order Month": data.om && poMonthFormate(data.om),

        'Receiver Name': data.rcId?.val,
        'Total Tax': data.tlTx,
        "Remarks": data.rmks,
        
        "Requested Amount":`₹ ${data.pyInfo?.apAmt  ? formatAmountIndianRupees(data.pyInfo?.apAmt) : Number(0).toFixed(2)}`,
        "Approved Amount":`₹ ${data.pyInfo?.tlAmt  ? formatAmountIndianRupees(data.pyInfo?.tlAmt) : Number(0).toFixed(2)}`,

        "Is It Refund Amount?": data?.rfdInfo?.sts ? "true" : "false",
       
        
      };
      
      if (data?.pyInfo?.list?.length > 0) {
        data.pyInfo.list.forEach((element, index) => {
          content[`Payment ${index + 1} Spent Amount`] = `₹ ${element?.amt  ? formatAmountIndianRupees(element?.amt) : Number(0).toFixed(2)}`;
          content[`Payment ${index + 1} Bank`] = element?.bnkId?.val;
          content[`Payment ${index + 1} Payee`] = element?.pyId?.val;
          content[`Payment ${index + 1} Date`] = element?.pmtDt &&
            moment(element?.pmtDt).format("DD-MMM-YYYY");
  
        
        });
      }
     
      content['Space Added'] = '--------------';

      content["Created AT"] = data.crAt ? moment(data.crAt).format("DD-MMM-YYYY") : '';

      return content;
    });
    return exportData;
  };